import React, { Component } from "react";
import {
  Button,
  Container,
  Header
} from "semantic-ui-react";

export default class BookPicWarning extends Component {
  render() {
    return (
      <Container text>
        <Header as="h1">22-25 Pictures</Header>
        <p>
          Note: Please submit 22-25 pictures. The books come with 20 pages, <br />
          a cover, and a back cover. If you submit less that 22 pictures the  <br />
          book will contain blank pages.
        </p>
        <Button primary onClick={this.props.onNext}>
          Next
        </Button>
      </Container>
    );
  }
}
